import { IEnvironment } from '@bca-core/models/environment';
import { appVersion } from '@bca/app.version';
export const environment: IEnvironment = {
  ...appVersion,
  production: true,
  name: 'nsbusinesscard2018',
  api: {
    mock: false,
    delayTime: 0,
    randomizeDelayTime: false,
  },
  receipt: {
    maxBuyableProducts: 5,
  },
  userData: {
    maxAge: 100,
    minAge: 12,
    useProductMinDays: 7,
    useProductMaxDays: 56,
    maxNumberOfFacesInImage: 1,
    maxImageFilzeSizeMb: 10,
    allowedImageMimeTypes: ['image/bmp', 'image/jpeg', 'image/png', 'image/tiff'],
  },
  agreement: {
    agreementPreviewFileType: 'application/pdf',
  },
  sentry: {
    key: '6b7c904aa7a2450b988b6f0bae13b84d',
    projectId: 232512,
  },
  nsBusinessUrl: 'https://www.ns.nl/zakelijk',
  nsBusinessUrlEnglish: 'https://www.ns.nl/en/business',
  optimizelySdk: 'VR4ethWQunYyaebzYfJ47',
  storageKeySerializer: 'Zgs99pwETVCx234h',
};
